import { render, staticRenderFns } from "./IP_ByFacility.vue?vue&type=template&id=981c5d26&scoped=true&"
import script from "./IP_ByFacility.vue?vue&type=script&lang=js&"
export * from "./IP_ByFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981c5d26",
  null
  
)

export default component.exports